var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons-container"},[_c(_vm.reference,{tag:"component",attrs:{"widget":_vm.widget}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }